import React from 'react'
import Bank1 from '../../assets/mainPage/banks/bank1.png'
import Bank2 from '../../assets/mainPage/banks/bank2.png'
import Bank3 from '../../assets/mainPage/banks/bank3.png'
import Bank4 from '../../assets/mainPage/banks/bank4.png'
import Bank5 from '../../assets/mainPage/banks/bank5.png'
import Bank6 from '../../assets/mainPage/banks/bank6.png'
import Bank7 from '../../assets/mainPage/banks/bank7.png'
import Bank8 from '../../assets/mainPage/banks/bank8.png'
import Bank9 from '../../assets/mainPage/banks/bank9.png'
import Bank10 from '../../assets/mainPage/banks/bank10.png'
import Bank11 from '../../assets/mainPage/banks/bank11.png'
import Bank12 from '../../assets/mainPage/banks/bank12.png'
import Bank13 from '../../assets/mainPage/banks/bank13.png'
import Bank14 from '../../assets/mainPage/banks/bank14.png'
import Bank15 from '../../assets/mainPage/banks/bank15.png'
import Bank16 from '../../assets/mainPage/banks/bank16.png'
import Bank17 from '../../assets/mainPage/banks/bank17.png'
import Bank18 from '../../assets/mainPage/banks/bank18.png'
import Bank19 from '../../assets/mainPage/banks/bank19.png'
import Bank20 from '../../assets/mainPage/banks/bank20.png'
import Bank21 from '../../assets/mainPage/banks/bank21.png'
import Bank22 from '../../assets/mainPage/banks/bank22.png'
import Bank23 from '../../assets/mainPage/banks/bank23.png'
import Bank24 from '../../assets/mainPage/banks/bank24.png'
import Bank25 from '../../assets/mainPage/banks/bank25.png'
import Bank26 from '../../assets/mainPage/banks/bank26.png'
import Bank27 from '../../assets/mainPage/banks/bank27.png'
import Bank28 from '../../assets/mainPage/banks/bank28.png'


const BankTable = () => {
    // return (
    //     <div style={{ marginBottom: '16rem', borderWidth: '0.1875rem' }} className="relative w-full rounded-2xl border border-gray-dddddd flex flex-col" >
    //         <div className="h-full w-full flex bg-gray-f9f9f9 rounded-t-2xl">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-20px m-auto w-121px' src={Bank1} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-7px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:30 ~ 00:05</p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-13px m-auto w-102px' src={Bank2} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-7px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:55 ~ 00:05</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f1f1f1">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-21px m-auto w-75px' src={Bank3} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-7px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00 ~ 01:00</p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-15px m-auto w-107px' src={Bank4} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-3px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00 ~ 00:10</p>
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px -mt-4px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">(금 00:00 ~ 00:40)</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f9f9f9">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img style={{ width: '96px' }} className='h-17px m-auto' src={Bank5} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-3px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00 ~ 01:00</p>
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px -mt-4px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">(일 00:00 ~ 08:00)</p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-19px m-auto w-90px' src={Bank6} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-7px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00 ~ 00:10</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f1f1f1">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='m-auto w-20px w-88px' src={Bank7} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-3px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:00 ~ 24:00</p>
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px -mt-4px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">(타행이체불가)</p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-14 m-auto w-94px' src={Bank8} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-7px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00 ~ 01:30</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f9f9f9">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-15px m-auto w-53px' src={Bank9} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-7px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:50 ~ 00:05</p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-19px m-auto w-90px' src={Bank10} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-3px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00 ~ 01:00</p>
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px -mt-4px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">(일 00:00 ~ 08:00)</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f1f1f1">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-16px m-auto w-83px' src={Bank11} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-7px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:50~00:10</p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-18px m-auto w-56px' src={Bank12} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-3px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:50~00:00</p>
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px -mt-4px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">(04:00 ~ 05:00)</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f9f9f9">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-24px m-auto w-94px' src={Bank13} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-5px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00~00:30 </p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-15px m-auto w-94px' src={Bank14} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-5px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00~00:20</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f1f1f1">
    //             <div style={{ height: '13.5rem', border: '0.1875rem solid #252525 #dddddd', borderLeft: 'none', borderTop: 'none' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-18px m-auto w-94px' src={Bank15} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-5px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:50~00:30</p>
    //                 </div>
    //             </div>
    //             <div style={{ height: '13.5rem', borderBottom: '0.1875rem solid #252525 #dddddd' }} className="flex table flex-wrap w-1/2 justify-center h-full">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-20px m-auto w-73px' src={Bank16} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-5px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">23:40~00:05</p>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="h-full w-full flex bg-gray-f9f9f9 rounded-b-2xl">
    //             <div style={{ height: '13.5rem' }} className="flex table flex-wrap w-full justify-center h-full rounded-b-2xl">
    //                 <div className="w-full table-cell align-middle" >
    //                     <img className='h-15px m-auto w-98px' src={Bank17} alt="" />
    //                     <p style={{ color: '#7b7b7b' }} className="text-10px mt-10px text-center font-spoqa tracking-tight text-gray-r7b7b7b w-full">00:00~00:30</p>
    //                 </div>
    //             </div>
    //         </div>

    //     </div>
    // )
    return (
        <div style={{ marginTop: '1.9rem', background: '#323232', padding: '0.1875rem', borderRadius: '1.3rem' }}>
            <div style={{ display: 'flex', height: '13.5rem', background: '' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank1} alt="" style={{ width: '22.1875rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:20</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank2} alt="" style={{ marginLeft: '-2rem', width: '17.8125rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>11:50 ~01:00
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '#2e2e2e', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank3} alt="" style={{ width: '16.874375rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:20</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank4} alt="" style={{ width: '23.186875rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>04:00 ~05:00
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.737rem', background: '', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank5} alt="" style={{ width: '23.125rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:10</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank6} alt="" style={{ width: '22.374375rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:20
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '#2e2e2e', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank7} alt="" style={{ marginTop: '-1.6rem', width: '26.125rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:30</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank8} alt="" style={{ marginTop: '-1.7rem', width: '15.5rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:40 ~00:05
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.6rem', background: '', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank9} alt="" style={{ marginTop: '-1.2rem', width: '11.125rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:10</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank10} alt="" style={{ marginTop: '-1.2rem', width: '19.0625rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:10
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '#2e2e2e', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank11} alt="" style={{ marginTop: '-1.2rem', width: '15.5rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:55 ~00:10</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank12} alt="" style={{ marginTop: '-1rem', marginLeft: '0.2rem', width: '22.1875rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:20
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank13} alt="" style={{ marginTop: '0.6rem', width: '20.8125rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~01:00</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank14} alt="" style={{ marginTop: '-1.8rem', marginLeft: '0.2rem', width: '23.25rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:10
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '#2e2e2e', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank15} alt="" style={{ marginTop: '-0.6rem', width: '22.1875rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:20</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank16} alt="" style={{ marginTop: '-0.1rem', marginLeft: '0.2rem', width: '16rem' }} />
                    </div>
                    <p style={{ margin: '-2rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:30
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank17} alt="" style={{ marginTop: '-0.6rem', width: '17.625rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:30</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank18} alt="" style={{ marginTop: '-0.3rem', marginLeft: '0rem', width: '24rem' }} />
                    </div>
                    <p style={{ margin: '-2rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:30
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '#2e2e2e', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank19} alt="" style={{ marginTop: '-0.6rem', width: '22.125rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~01:00</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank20} alt="" style={{ marginTop: '-0.3rem', marginLeft: '0rem', width: '21.248125rem' }} />
                    </div>
                    <p style={{ margin: '-2rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:55 ~00:35
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank21} alt="" style={{ marginTop: '-0.6rem', width: '21.248125rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:05 ~00:20</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank22} alt="" style={{ marginTop: '-0.3rem', marginLeft: '0rem', width: '22.1875rem' }} />
                    </div>
                    <p style={{ margin: '-2rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:05
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '#2e2e2e', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank23} alt="" style={{ marginTop: '-0.8rem', width: '17.75rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:10</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank24} alt="" style={{ marginTop: '-0.3rem', marginLeft: '0rem', width: '26.25rem' }} />
                    </div>
                    <p style={{ margin: '-2rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:20
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank25} alt="" style={{ marginTop: '-0.8rem', marginLeft: '0.1rem', width: '22.1875rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>00:00 ~00:05</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank26} alt="" style={{ marginTop: '-0.3rem', marginLeft: '0.1rem', width: '20.05625rem' }} />
                    </div>
                    <p style={{ margin: '-2rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:30
                    </p>
                </div>
            </div>
            <div style={{ display: 'flex', height: '13.7rem', background: '', borderTop: '0.1875rem solid #252525' }}>
                <div style={{ width: '50%', textAlign: 'center', borderRight: '0.1875rem solid #252525' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank27} alt="" style={{ marginTop: '-1.6rem', marginLeft: '0', width: '20rem' }} />
                    </div>
                    <p style={{ margin: '-1.5rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:30</p>
                </div>
                <div style={{ width: '50%', textAlign: 'center' }}>
                    <div style={{ height: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Bank28} alt="" style={{ marginTop: '1rem', marginLeft: '0.1rem', width: '19.18375rem' }} />
                    </div>
                    <p style={{ margin: '-1.6rem 0 0 -0rem', color: '#c8c8c8', fontSize: '2.25rem', fontFamily: 'SpoqaHanSansNeo', letterSpacing: '-0.05rem' }}>23:50 ~00:30
                    </p>
                </div>
            </div>
        </div>
    )
}

export default BankTable


